"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundedSearch = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const svg_1 = require("../../svg/");
const flex_1 = require("../../layout/flex");
const base_input_1 = require("./base_input");
const label_1 = __importDefault(require("../../typography/label"));
const styled_1 = __importDefault(require("../../../styles/styled"));
const theme_1 = require("../../../styles/theme");
const Container = (0, styled_1.default)(flex_1.Flex)(({ theme }) => ({
    height: 40,
    alignItems: 'center',
    background: theme.colors.grey05,
    borderRadius: 32,
    padding: '8px 16px',
    ':focus-within': theme_1.focus.shadow,
    '::placeholder': {
        color: theme.colors.grey30,
    },
    ':hover': {
        backgroundColor: theme.colors.hoverBlue,
    },
}));
const RoundedSearch = (_a) => {
    var _b;
    var { name } = _a, rest = __rest(_a, ["name"]);
    const value = ((_b = rest.value) === null || _b === void 0 ? void 0 : _b.toString()) || '';
    const baseInputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (value) {
            const inputLength = value.length;
            baseInputRef.current.setSelectionRange(inputLength, inputLength);
            baseInputRef.current.focus();
        }
        // only run on initial mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsx)(svg_1.SearchGlassIcon, {}), (0, jsx_runtime_1.jsx)(label_1.default, Object.assign({ htmlFor: name, screenReaderOnly: true }, { children: name })), (0, jsx_runtime_1.jsx)(base_input_1.BaseInput, Object.assign({ ref: baseInputRef, id: name, autoFocus: true, name: name, ml: 1, fontSize: 1 }, rest))] }));
};
exports.RoundedSearch = RoundedSearch;
//# sourceMappingURL=rounded_search.js.map